import React, { useEffect, useState } from 'react'
import { Alert, Chip, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material'
import API from '../../../services/API'

// Fleet-wide top-10 lists sitting above the paginated History table - turns
// the audit trail from a flat log into "what needs attention" at a glance.
// Fetched once on mount; only reports recorded after the `issues` field
// existed contribute (see server-side comment on GET /makeready/trends).
const MakeReadyTrends = () => {
  const [loading, setLoading] = useState(true)
  const [topVehiclesAssets, setTopVehiclesAssets] = useState([])
  const [topItems, setTopItems] = useState([])

  useEffect(() => {
    API.get('/makeready/trends')
      .then((res) => {
        if (res.status === 200) {
          setTopVehiclesAssets(res.data.topVehiclesAssets || [])
          setTopItems(res.data.topItems || [])
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rounded" height={140} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rounded" height={140} />
        </Grid>
      </Grid>
    )
  }

  if (topVehiclesAssets.length === 0 && topItems.length === 0) return null

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="title2" fontSize="1rem" mb={1}>
            Needing attention most
          </Typography>
          {topVehiclesAssets.length === 0 ? (
            <Alert severity="success">Nothing stands out across the fleet.</Alert>
          ) : (
            <Stack gap={1}>
              {topVehiclesAssets.map((row) => (
                <Stack
                  key={row.label}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography>{row.label}</Typography>
                  <Chip
                    size="small"
                    color="error"
                    label={`${row.issueCount} check(s) with issues`}
                  />
                </Stack>
              ))}
            </Stack>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="title2" fontSize="1rem" mb={1}>
            Items running short most often
          </Typography>
          {topItems.length === 0 ? (
            <Alert severity="success">No recurring shortfalls.</Alert>
          ) : (
            <Stack gap={1}>
              {topItems.map((row) => (
                <Stack
                  key={`${row.name}|${row.size}`}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography>
                    {row.name} {row.size && `(${row.size})`}
                  </Typography>
                  <Chip
                    size="small"
                    color="warning"
                    label={`${row.occurrences} check(s)`}
                  />
                </Stack>
              ))}
            </Stack>
          )}
        </Paper>
      </Grid>
    </Grid>
  )
}

export default MakeReadyTrends
